/* import __COLOCATED_TEMPLATE__ from './question.hbs'; */
import { PRESCREENER_CLIENT_TYPES } from 'client-portal/utils/prescreener/constants';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestPrescreenerQuestion extends Component {
  @service prescreener;

  get clientType() {
    return this.args.clientType || PRESCREENER_CLIENT_TYPES.client;
  }

  get validationModel() {
    return this.prescreener.validation.getValidatedAnswerModel(this.args.question, this.clientType);
  }

  get isInvalid() {
    const validation = this.validationModel?.validations?.attrs?.value;
    return validation?.isInvalid && this.showForcedValidation;
  }

  get showForcedValidation() {
    return this.prescreener.validation.forceValidation;
  }

  get isClientTypeAware() {
    return this.args.question?.isClientTypeAware;
  }

  get canShowForContactForm() {
    return this.args.question?.showToContact && this.args.isForContact;
  }

  get canShowForCoupleForm() {
    return this.args.question?.showToCouple && this.args.isForCouple;
  }

  get showForContact() {
    return this.canShowForContactForm && this.clientType === PRESCREENER_CLIENT_TYPES.contact;
  }

  get showForCouple() {
    return this.canShowForCoupleForm && this.clientType === PRESCREENER_CLIENT_TYPES.partner;
  }

  get showForClient() {
    return (
      !this.isClientTypeAware ||
      this.clientType === PRESCREENER_CLIENT_TYPES.client ||
      this.canShowForContactForm ||
      this.canShowForCoupleForm
    );
  }

  get shouldShowForClientType() {
    return this.showForClient || this.showForContact || this.showForCouple;
  }
}
